<aside class="notification-sidebar" id="notification-sidebar" [ngClass]="{ open: isOpen }" #notificationSidebar>
  <a class="notification-sidebar-close" (click)="onClose()">
    <i class="ft-x font-medium-3 grey darken-1"></i>
  </a>

  <div class="side-nav notification-sidebar-content">
    <div class="row">
      <div class="col-12 notification-tab-content">
        <div class="p-1">
          <h4 class="text-bold-500">Make Payment</h4>
        </div>
        <div class="border-bottom mb-2"></div>
        <div class="row tab-pane" id="activity-tab" role="tabpanel" aria-expanded="true" aria-labelledby="base-tab1">
          <div class="col-12 text-center" id="activity">
            <ng-container>
              <div class="text-center mb-2">
                <img src="/assets/img/pos-device.png" class="img-fluid" style="max-width:200px; object-fit:contain;">
              </div>

              <div class="text-center">
                <h5 style="font-weight: 600">Total Amount</h5>
                <h4 class="text-bold-600">{{ amount }} INR</h4>
              </div>

              <div class="methods" role="group" aria-label="Payment methods">

                <button type="button" class="btn-custom btn border border-primary"
                  [ngClass]="selectedMethod === 'cash' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="onMethodClick('cash')">
                  <i class="fa-solid fa-money-bill"></i>
                  <span>CASH</span>
                </button>

                <button type="button" class="btn-custom btn border border-primary"
                  [ngClass]="selectedMethod === 'card' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="onMethodClick('card')">
                  <i class="fa-solid fa-credit-card"></i>
                  CARD
                </button>

                <button type="button" class="btn-custom btn border border-primary"
                  [ngClass]="selectedMethod === 'upi' ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="onMethodClick('upi')">
                  <i class="fa-solid fa-qrcode"></i>
                  UPI
                </button>
              </div>

              <div class="device-list">
                <div class="device-items" role="list" aria-label="POS devices">
                  <button class="device-btn" *ngFor="let i = index"
                    [class.selected]="selectedDeviceIndex === i" (click)="selectDevice(i)"
                    [attr.aria-pressed]="selectedDeviceIndex === i" role="listitem" type="button">
                    {{ d.name }}
                  </button>
                </div>
              </div>

            </ng-container>

            <ng-container *ngIf="resultStatus">
              <div class="result-card">
                <div class="result-inner" [ngClass]="resultStatus">
                  <div class="result-illustration">
                    <ng-container *ngIf="resultStatus === 'success'">
                      <img src="/assets/img/icons/check.png" alt="Payment Success" class="result-icon" />
                    </ng-container>
                    <ng-container *ngIf="resultStatus === 'failed'">
                      <img src="/assets/img/icons/close.png" alt="Payment Failed" class="result-icon" />
                    </ng-container>
                  </div>

                  <h3 class="result-title">{{ resultTitle }}</h3>

                  <div class="result-amount">
                    <div class="label">Total Amount</div>
                    <div class="value"><strong>{{ resultAmount }}</strong> INR</div>
                  </div>

                  <div class="result-actions">
                    <button *ngIf="resultStatus === 'success'" class="result-btn success" type="button"
                      (click)="onResultDone()">
                      Done
                    </button>
                    <button *ngIf="resultStatus === 'failed'" class="result-btn failed" type="button"
                      (click)="resetResult(); showTransaction=false; resetDeviceSelection();">Try Again
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="selectedMethod === 'cash'"
          class="p-3 border-top bg-white d-flex justify-content-center align-items-center" role="region"
          aria-live="polite" aria-label="Confirm cash payment" style="min-height: auto;">
          <button class="btn btn-success btn-lg rounded-pill w-100 shadow" type="button" (click)="confirmCashPayment()"
            aria-label="Confirm Payment">
            Confirm Payment
          </button>
        </div>
      </div>
    </div>
  </div>

</aside>